import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const SameDayRide = styled(Box)`
  border: 1.2px solid ${colorTokens.border.dark};
  border-radius: 6px;
  gap: 12px;
  padding: 13.2px 27.6px;
`;
